// Add grid code route (/admin/datasets/new): the family (adding a version), the stored source file (sha256) and the wizard step 1-5 in the URL; the screen is NewGridCodePage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { numberWithDefault, optionalString } from "@/app/search";
import { NewGridCodePage } from "@/features/datasets/NewGridCodePage";

const searchSchema = z.object({
  family: optionalString(),
  file: optionalString(),
  step: numberWithDefault(1, 1, 5),
});

export const Route = createFileRoute("/_app/admin/datasets/new")({
  validateSearch: searchSchema,
  staticData: { crumb: "Add grid code" },
  component: NewGridCodePage,
});
